<ion-content>
  <app-global-page-header
    [title]="'P00039.parameters.setting.clockweek' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="text-center">
    <div class="p-4">
      <div class="box-white-rounded-xs pt-3 pe-3">
        <div class="w-100 position-relative" style="height: 300px">
          <div
            style="
              position: absolute;
              left: 0px;
              bottom: 30px;
              top: 0px;
              width: 50px;
            "
          >
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">100%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">90%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">80%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">70%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">60%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">50%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">40%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">30%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">20%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">10%</div>
              </div>
            </div>
            <div
              style="height: 10%; transform: translateY(-50%)"
              class="color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">0%</div>
              </div>
            </div>
          </div>

          <div
            style="
              position: absolute;
              left: 50px;
              bottom: 30px;
              top: 0px;
              width: 1px;
            "
            class="border-right"
          ></div>

          <div
            style="
              position: absolute;
              left: 50px;
              bottom: 30px;
              right: 0px;
              height: 1px;
            "
            class="border-top"
          ></div>

          <div
            class="text-start"
            style="
              position: absolute;
              left: 50px;
              bottom: 30px;
              right: 0px;
              top: 0px;
              white-space: nowrap !important;
            "
          >
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 10%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 20%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 30%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 40%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 50%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 60%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 70%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 80%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 90%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>
            <div
              style="
                position: absolute;
                left: 00px;
                bottom: 100%;
                right: 0px;
                height: 1px;
              "
              class="border-top"
            ></div>

            @for (testModel of this.horlogesModel; track testModel) {
              <div
                title="{{ testModel.end - testModel.start }}"
                [style]="
                  'left:' +
                  getLeftPos(testModel.start) +
                  '%; width:' +
                  getSize(testModel.end - testModel.start) +
                  '%; height:' +
                  testModel.consigne +
                  '%;background-color: var(--ion-color-primary);'
                "
                class="position-absolute bottom-0"
              ></div>
            }
          </div>

          <div
            style="
              position: absolute;
              left: 50px;
              bottom: 0px;
              right: 0px;
              height: 30px;
              white-space: nowrap !important;
            "
          >
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">0</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">2</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">4</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">6</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">8</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">10</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">12</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">14</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">16</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">18</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">20</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">22</div>
              </div>
            </div>
            <div
              style="height: 100%; width: 8.33%; transform: translateX(-50%)"
              class="d-inline-block color-medium fs-10 position-relative"
            >
              <div class="row h-100 align-items-center">
                <div class="col text-center">0</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (this.horlogesModel.length > 0) {
    <div class="my-4">
      <div class="px-4 mb-3">
        <ion-label class="color-medium text-uppercase fw-bold">{{
          'functions.horlogeprogrammation.clock.plageprogramme' | translate
        }}</ion-label>
      </div>

      @for (testModel of this.horlogesModel; track testModel) {
        <ion-list lines="none">
          <ion-item
            class="pointer-hover py-1 px-4"
            (click)="openModal(testModel)"
          >
            <ion-label>
              {{ secondeToHourMinute(testModel.start) }}
              {{ 'functions.horlogeprogrammation.timer.a' | translate }}
              {{ secondeToHourMinute(testModel.end) }}
            </ion-label>

            <div slot="end">
              <span class="d-inline-block me-2 color-primary">
                {{ testModel.consigne }} %
              </span>
              <i class="fa-regular fa-pen color-primary"></i>
            </div>
          </ion-item>
        </ion-list>
      }
    </div>
  }

  <!-- Modal inline -->
  <ion-modal [isOpen]="isModalOpen" (didDismiss)="closeModal()">
    <ng-template>
      @if (selectModelStep === 0) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <ion-label class="color-medium text-uppercase fw-bold">
                {{ 'P00037.parameters.controle.consigne' | translate }}
              </ion-label>
            </div>

            <div>
              <ion-list lines="none">
                @for (item of P00037ConsigneManuel; track item.ref) {
                  <ion-item
                    class="pointer-hover py-1 px-4"
                    (click)="selectConsigne(item.ref)"
                  >
                    <ion-label>
                      <span
                        [class.color-primary]="
                          selectModel?.consigne === item.ref
                        "
                      >
                        {{ item.label | translate }}
                      </span>
                    </ion-label>

                    @if (selectModel?.start === item.ref) {
                      <div slot="end" class="color-primary">
                        <i class="fa-regular fa-check"></i>
                      </div>
                    }
                  </ion-item>
                }
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button expand="block" color="primary" (click)="nextStep()">
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      } @else if (selectModelStep === 1) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <ion-label class="color-medium text-uppercase fw-bold">
                {{ 'selectTimeInterval.start' | translate }}
              </ion-label>
            </div>

            <div>
              <ion-list lines="none">
                @for (item of this.list; track item.ref) {
                  <ion-item
                    class="pointer-hover py-1 px-4"
                    (click)="selectStart(item.ref)"
                  >
                    <ion-label>
                      <span
                        [class.color-primary]="selectModel?.start === item.ref"
                      >
                        {{ item.label | translate }}
                      </span>
                    </ion-label>

                    @if (selectModel?.start === item.ref) {
                      <div slot="end" class="color-primary">
                        <i class="fa-regular fa-check"></i>
                      </div>
                    }
                  </ion-item>
                }
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button expand="block" color="primary" (click)="nextStep()">
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      } @else if (selectModelStep === 2) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <ion-label class="color-medium text-uppercase fw-bold">
                {{ 'selectTimeInterval.end' | translate }}
              </ion-label>
            </div>

            <div>
              <ion-list lines="none">
                @for (item of this.list; track item.ref) {
                  <ion-item
                    class="pointer-hover py-1 px-4"
                    (click)="selectEnd(item.ref)"
                  >
                    <ion-label>
                      <span
                        [class.color-primary]="selectModel?.end === item.ref"
                      >
                        {{ item.label | translate }}
                      </span>
                    </ion-label>

                    @if (selectModel?.end === item.ref) {
                      <div slot="end" class="color-primary">
                        <i class="fa-regular fa-check"></i>
                      </div>
                    }
                  </ion-item>
                }
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button expand="block" color="primary" (click)="nextStep()">
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      } @else if (selectModelStep === 3) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <div class="row">
                <div class="col">
                  <ion-label class="color-medium text-uppercase fw-bold">{{
                    'selectTimeInterval.plage' | translate
                  }}</ion-label>
                </div>
                <div class="col-auto">
                  <div
                    class="d-inline-block pointer-hover"
                    (click)="deleteModel()"
                  >
                    <i class="fa-regular fa-trash color-primary"> </i>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <ion-list lines="none">
                <ion-item class="pointer-hover py-1 px-4" (click)="goToStep(0)">
                  <ion-label>
                    {{ 'P00037.parameters.controle.consigne' | translate }}
                  </ion-label>

                  <div slot="end">
                    <span class="d-inline-block me-2 color-primary">
                      {{ this.selectModel?.consigne }} %
                    </span>
                  </div>
                </ion-item>
                <ion-item class="pointer-hover py-1 px-4" (click)="goToStep(1)">
                  <ion-label>
                    {{ 'selectTimeInterval.start' | translate }}
                  </ion-label>

                  <div slot="end">
                    {{ getStartDate() }}
                  </div>
                </ion-item>
                <ion-item class="pointer-hover py-1 px-4" (click)="goToStep(2)">
                  <ion-label>
                    {{ 'selectTimeInterval.end' | translate }}
                  </ion-label>

                  <div slot="end">
                    {{ getEndDate() }}
                  </div>
                </ion-item>
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button
                  expand="block"
                  color="primary"
                  (click)="saveModel()"
                >
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      }
    </ng-template>
  </ion-modal>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12">
        <ion-button color="primary" expand="block" (click)="openModal()">
          {{ 'functions.horlogeprogrammation.clock.btn' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
